import { CoreSpace } from '@densityco/lib-api-types';
import { Space } from 'components/editor/state';
import { polygonalArea } from './units';

export const isSingleOccupancy = (space: CoreSpace) => {
  return space.capacity === 1;
};

export function calculateArea(space: Space) {
  if (space.shape.type === 'circle') {
    return Math.PI * space.shape.radius ** 2;
  } else if (space.shape.type === 'box') {
    return space.shape.width * space.shape.height;
  } else {
    return polygonalArea(space.shape.vertices);
  }
}
